import { immerable } from 'immer';

import { ModuleInstanceType } from '../domain/module-role';

interface IFeatures {
	canResetUserPassword: boolean;
	canManageUsers: boolean;
	canManageUserLogin: boolean;
	canManageUserRoles: boolean;
	canManageMyTokens: boolean;
	canManageUserTokens: boolean;
	canManageGroups: boolean;
	canManageGroupRoles: boolean;
	canManageInstances: boolean;
	enabledInstanceTypes: Array<ModuleInstanceType>;
	canManageOrganizations: boolean;
}

const entityDefaults: IFeatures = {
	canResetUserPassword: false,
	canManageUsers: false,
	canManageUserLogin: false,
	canManageUserRoles: false,
	canManageMyTokens: false,
	canManageUserTokens: false,
	canManageGroups: false,
	canManageGroupRoles: false,
	canManageInstances: false,
	enabledInstanceTypes: [],
	canManageOrganizations: false,
};

export class Features implements IFeatures {
	private [immerable] = true;
	public canResetUserPassword = entityDefaults.canResetUserPassword;
	public canManageUsers = entityDefaults.canManageUsers;
	public canManageUserLogin = entityDefaults.canManageUserLogin;
	public canManageUserRoles = entityDefaults.canManageUserRoles;
	public canManageMyTokens = entityDefaults.canManageMyTokens;
	public canManageUserTokens = entityDefaults.canManageUserTokens;
	public canManageGroups = entityDefaults.canManageGroups;
	public canManageGroupRoles = entityDefaults.canManageGroupRoles;
	public canManageInstances = entityDefaults.canManageInstances;
	public enabledInstanceTypes = entityDefaults.enabledInstanceTypes;
	public canManageOrganizations = entityDefaults.canManageOrganizations;

	public static build(params: Partial<IFeatures> = {}): Features {
		const inst = new Features();
		inst.canResetUserPassword =
			params.canResetUserPassword ?? entityDefaults.canResetUserPassword;
		inst.canManageUsers =
			params.canManageUsers ?? entityDefaults.canManageUsers;
		inst.canManageUserLogin =
			params.canManageUserLogin ?? entityDefaults.canManageUserLogin;

		inst.canManageUserRoles =
			params.canManageUserRoles ?? entityDefaults.canManageUserRoles;
		inst.canManageMyTokens =
			params.canManageMyTokens ?? entityDefaults.canManageMyTokens;
		inst.canManageUserTokens =
			params.canManageUserTokens ?? entityDefaults.canManageUserTokens;

		inst.canManageGroups =
			params.canManageGroups ?? entityDefaults.canManageGroups;
		inst.canManageGroupRoles =
			params.canManageGroupRoles ?? entityDefaults.canManageGroupRoles;
		inst.canManageInstances =
			params.canManageInstances ?? entityDefaults.canManageInstances;
		inst.enabledInstanceTypes =
			params.enabledInstanceTypes ?? entityDefaults.enabledInstanceTypes;
		inst.canManageOrganizations =
			params.canManageOrganizations ?? entityDefaults.canManageOrganizations;

		return inst;
	}
}
